<script setup lang="ts">
  import { Icon as IconifyIcon } from '@iconify/vue/offline'

  withDefaults(
    defineProps<{
      icon?: string
      size?: number | string
      color?: string
    }>(),
    {
      icon: '',
      size: 16,
      color: undefined
    }
  )
</script>

<template>
  <span
    v-if="icon"
    class="v-icon"
    :style="{ '--v-icon-color': color, '--v-icon-size': typeof size === 'number' ? `${size}px` : size }"
  >
    <IconifyIcon :icon="icon" :width="size" :height="size" />
  </span>
</template>

<style scoped>
  .v-icon {
    display: inline-flex;
    color: var(--v-icon-color, currentcolor);
    font-size: var(--v-icon-size, 16px);
    line-height: 1;
    vertical-align: middle;
  }
</style>